// SPDX-License-Identifier: Apache-2.0
import LayerWmsExternal from './layerwmsexternal';
import LayerWmtsExternal from './layerwmtsexternal';
import ThemeLayer from './themelayer';

/*
 * This class is a used in the state of the application, which will be accessed behind a javascript proxy.
 * This means that each modification made to its properties must come from outside,
 * because they have to be made through the proxy, so that the modification can be listen.
 * Therefore, this class must not contain any method which is updating a value directly
 * For example, any method doing <this.xxx = value> is forbidden here, because the modification be known from the proxy
 */
export default class ThemeLayerExternal extends ThemeLayer {
  private static nextAvailableThemeId = 30000000;

  public constructor(name?: string) {
    const id = ThemeLayerExternal.nextAvailableThemeId++;
    super(id, name ?? 'Unknown external service', 0);
  }

  public override children: (LayerWmtsExternal | LayerWmsExternal)[] = [];
}
